import createReducer from 'redux/lib/reducerConfig';

import { SurveyJobSearchField } from 'types';

const ActionTypes = {
  SET_ADD_SURVEY_FILTER: 'SET_ADD_SURVEY_FILTER',
  RESET_ADD_SURVEY_FILTER: 'RESET_ADD_SURVEY_FILTER',
};

export const setAddSurveyFilter = (filter) => ({
  type: ActionTypes.SET_ADD_SURVEY_FILTER,
  payload: filter,
});

export const resetAddSurveyFilter = () => ({
  type: ActionTypes.RESET_ADD_SURVEY_FILTER,
});

export const filterInitialState = {
  vendor: [],
  effectiveDate: [],
  jobFamily: [],
  jobSubFamily: [],
  jobFocus: [],
  careerLevel: [],
  globalLevel: [],
  survey: [],
  industry: [],
  location: [],
  companySize: [],
  dataCuts: 'mapped',
  recommended: false,
  search: [],
  searchFields: Object.values(SurveyJobSearchField),
};

export const addSurveyFilterReducer = createReducer(
  filterInitialState,
  {
    [ActionTypes.SET_ADD_SURVEY_FILTER]: (state, { payload }) => {
      return { ...state, ...payload };
    },
    [ActionTypes.RESET_ADD_SURVEY_FILTER]: () => {
      return filterInitialState;
    },
  },
);
